import * as React from 'react';
export const MenuContext = React.createContext({
    onActionClick: () => null,
    onSelect: () => null,
    activeItemId: null,
    selected: null
});
export const MenuItemContext = React.createContext({
    itemId: null,
    isDisabled: false
});
//# sourceMappingURL=MenuContext.js.map